import { render, staticRenderFns } from "./HomeBanner.vue?vue&type=template&id=16e5cc4b&scoped=true"
import script from "./HomeBanner.vue?vue&type=script&lang=js"
export * from "./HomeBanner.vue?vue&type=script&lang=js"
import style0 from "./HomeBanner.vue?vue&type=style&index=0&id=16e5cc4b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e5cc4b",
  null
  
)

export default component.exports